import { useState } from 'react';

export default function InvitePlayersModal({ show, onClose, allUsers, players, onInvite, sentInvites }) {
  const [search, setSearch] = useState('');

  if (!show) return null;

  const playerIds = players.map(p => p.id);
  const filtered = allUsers
    .filter(u => !playerIds.includes(u.id))
    .filter(u => u.name.toLowerCase().includes(search.toLowerCase()));

  function isInvited(userId) {
    return sentInvites.some(inv => inv.toUserId === userId);
  }

  return (
    <div className="blurred-app-state" onClick={onClose}>
      <div className="modal-card invite-modal" onClick={e => e.stopPropagation()}>
        <h2>invite players</h2>

        <input
          type="text"
          className="name-input invite-search"
          placeholder="Search players..."
          value={search}
          onChange={e => setSearch(e.target.value)}
        />

        <div className="invite-user-list">
          {filtered.length === 0 && (
            <p className="invite-empty">No players found</p>
          )}
          {filtered.map(u => (
            <div key={u.id} className="invite-user-row">
              <span className="invite-user-name">{u.name}</span>
              {isInvited(u.id) ? (
                <span className="invite-sent-label">Sent</span>
              ) : (
                <button className="invite-send-btn" onClick={() => onInvite(u.id, u.name)}>
                  Invite
                </button>
              )}
            </div>
          ))}
        </div>

        <button className="btn-bank" style={{ marginTop: 15 }} onClick={onClose}>Done</button>
      </div>
    </div>
  );
}
